module.exports = __webpack_public_path__ + "static/media/PJDAEA.crop.5194d949.jpg";